import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Footer from "../../components/comunes/Footer";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth";
import { Spinner, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight, faChartLine } from "@fortawesome/free-solid-svg-icons";

const MetaPaginas = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [cargando, setCargando] = useState(true);
    const [paginas, setPaginas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(null);
    const [metricas, setMetricas] = useState(null);
    const [loadingMetricas, setLoadingMetricas] = useState(false);

    useEffect(() => {
        const verificar = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const r = await fetch(process.env.REACT_APP_API_TOKEN, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (!r.ok) navegacion("/");
            } catch { navegacion("/"); }
            finally { setCargando(false); }
        };
        verificar();
    }, [navegacion]);

    const cargarPaginas = async () => {
        setLoading(true);
        setError(null);
        setPaginaSeleccionada(null);
        setMetricas(null);
        try {
            const r = await fetch("/api/meta/paginas");
            const data = await r.json();
            if (!r.ok) { setError(data.error || `Error ${r.status}`); return; }
            setPaginas(data);
        } catch {
            setError("No se pudo conectar con Meta. Verificá la configuración del token.");
        } finally {
            setLoading(false);
        }
    };

    const verMetricas = async (pagina) => {
        setPaginaSeleccionada(pagina);
        setMetricas(null);
        setLoadingMetricas(true);
        try {
            const r = await fetch(`/api/meta/paginas/${pagina.id}/metricas`);
            const data = await r.json();
            if (!r.ok) { setMetricas({ error: data.error }); return; }
            setMetricas(data);
        } catch {
            setMetricas({ error: "No se pudieron cargar las métricas." });
        } finally {
            setLoadingMetricas(false);
        }
    };

    useEffect(() => { if (!cargando) cargarPaginas(); }, [cargando]);

    if (cargando) return null;

    const cardStyle = {
        borderRadius: 12,
        padding: "18px 22px",
        background: darkMode ? "#2c2f36" : "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        border: `1px solid ${darkMode ? "#3d4148" : "#e9ecef"}`,
        marginBottom: 20,
    };

    return (
        <div className={darkMode ? "bg-dark text-white min-vh-100" : "bg-light min-vh-100"}>
            <div className="container-fluid py-4 px-4">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <div>
                        <h5 className="mb-1 fw-bold">Páginas de Facebook</h5>
                        <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                            Páginas administradas y sus métricas de engagement.
                        </p>
                    </div>
                    <button className="btn btn-sm btn-outline-secondary" onClick={cargarPaginas} disabled={loading}>
                        <FontAwesomeIcon icon={faRotateRight} /> Actualizar
                    </button>
                </div>

                {loading ? (
                    <div className="text-center py-5"><Spinner animation="border" /></div>
                ) : error ? (
                    <AlertConfig mensaje={error} darkMode={darkMode} />
                ) : (
                    <div className="row g-3">
                        {paginas.length === 0 ? (
                            <div className="col-12">
                                <div style={cardStyle}>
                                    <p className="text-muted mb-0" style={{ fontSize: 13 }}>No se encontraron páginas asociadas al token.</p>
                                </div>
                            </div>
                        ) : paginas.map(p => (
                            <div className="col-12 col-md-6 col-xl-4" key={p.id}>
                                <div style={{
                                    ...cardStyle,
                                    marginBottom: 0,
                                    borderLeft: paginaSeleccionada?.id === p.id ? "4px solid #1877F2" : undefined,
                                }}>
                                    <div className="d-flex align-items-center gap-3 mb-3">
                                        {p.picture?.data?.url ? (
                                            <img src={p.picture.data.url} alt={p.name}
                                                style={{ width: 48, height: 48, borderRadius: "50%", objectFit: "cover" }} />
                                        ) : (
                                            <div style={{
                                                width: 48, height: 48, borderRadius: "50%",
                                                background: "#1877F2", display: "flex", alignItems: "center",
                                                justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 20,
                                            }}>
                                                {p.name?.[0] || "P"}
                                            </div>
                                        )}
                                        <div>
                                            <div style={{ fontWeight: 700, fontSize: 15 }}>{p.name}</div>
                                            <div style={{ fontSize: 12, color: darkMode ? "#aaa" : "#666" }}>{p.category}</div>
                                        </div>
                                    </div>
                                    <div className="d-flex gap-4 mb-3">
                                        <div>
                                            <div style={{ fontSize: 20, fontWeight: 700, color: "#1877F2" }}>
                                                {(p.fan_count ?? 0).toLocaleString("es-AR")}
                                            </div>
                                            <div style={{ fontSize: 11, color: darkMode ? "#aaa" : "#666" }}>Me gusta</div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 20, fontWeight: 700, color: "#1877F2" }}>
                                                {(p.followers_count ?? 0).toLocaleString("es-AR")}
                                            </div>
                                            <div style={{ fontSize: 11, color: darkMode ? "#aaa" : "#666" }}>Seguidores</div>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-sm btn-outline-primary w-100"
                                        onClick={() => verMetricas(p)}
                                        disabled={loadingMetricas && paginaSeleccionada?.id === p.id}
                                    >
                                        <FontAwesomeIcon icon={faChartLine} className="me-1" />
                                        Ver métricas
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Panel de métricas de la página seleccionada */}
                {paginaSeleccionada && (
                    <div style={{ ...cardStyle, marginTop: 24 }}>
                        <h6 className="fw-bold mb-3">
                            Métricas — {paginaSeleccionada.name}
                            <span style={{ fontSize: 12, fontWeight: 400, color: darkMode ? "#aaa" : "#666", marginLeft: 8 }}>
                                últimos 28 días
                            </span>
                        </h6>
                        {loadingMetricas ? (
                            <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>
                        ) : metricas?.insights ? (
                            <MetricasInsights insights={metricas.insights} darkMode={darkMode} />
                        ) : (
                            <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                                {metricas?.insightsError
                                    ? "Métricas no disponibles para esta página. Puede que sea nueva o aún no tenga actividad registrada."
                                    : "Sin datos de métricas."}
                            </p>
                        )}
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

function MetricasInsights({ insights, darkMode }) {
    const LABELS = {
        page_impressions: { label: "Impresiones",     color: "#1877F2" },
        page_fan_adds:    { label: "Nuevos Me gusta", color: "#e91e63" },
        page_views_total: { label: "Visitas",         color: "#9c27b0" },
    };

    if (!insights || !Array.isArray(insights)) return null;

    return (
        <div className="row g-3">
            {insights.map((metric, i) => {
                const meta = LABELS[metric.name] || { label: metric.name, color: "#888" };
                const ultimo = metric.values?.[metric.values.length - 1];
                const valor = ultimo?.value ?? 0;
                return (
                    <div className="col-6 col-md-4 col-xl-3" key={i}>
                        <div style={{
                            borderRadius: 10,
                            padding: "14px 16px",
                            background: darkMode ? "#1e2126" : "#f8f9fa",
                            borderTop: `3px solid ${meta.color}`,
                        }}>
                            <div style={{ fontSize: 24, fontWeight: 700, color: meta.color }}>
                                {typeof valor === "number" ? valor.toLocaleString("es-AR") : valor}
                            </div>
                            <div style={{ fontSize: 12, color: darkMode ? "#aaa" : "#666", marginTop: 2 }}>
                                {meta.label}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

function AlertConfig({ mensaje, darkMode }) {
    return (
        <div style={{
            borderRadius: 12, padding: "20px 24px",
            background: darkMode ? "#2c2f36" : "#fff",
            border: "1px solid #dc3545", borderLeft: "4px solid #dc3545",
        }}>
            <h6 className="fw-bold text-danger mb-2">No se pudo conectar con Meta</h6>
            <p style={{ fontSize: 13, marginBottom: 10 }}>{mensaje}</p>
            <p style={{ fontSize: 12, color: darkMode ? "#aaa" : "#666", marginBottom: 0 }}>
                Configurá <code>Meta:PageAccessToken</code> en appsettings.json o en las variables de entorno del servidor.
            </p>
        </div>
    );
}

export default MetaPaginas;
